module.exports = __webpack_public_path__ + "img/elementary.4bfa9ee0.jpg";